var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 1.8913V5.33342C11.6666 5.80013 11.6666 6.03348 11.7574 6.21174C11.8373 6.36854 11.9648 6.49603 12.1216 6.57592C12.2999 6.66675 12.5332 6.66675 12.9999 6.66675H16.442M16.6666 8.3236V14.3334C16.6666 15.7335 16.6666 16.4336 16.3941 16.9684C16.1544 17.4388 15.772 17.8212 15.3016 18.0609C14.7668 18.3334 14.0667 18.3334 12.6666 18.3334H7.33325C5.93312 18.3334 5.23306 18.3334 4.69828 18.0609C4.22787 17.8212 3.84542 17.4388 3.60574 16.9684C3.33325 16.4336 3.33325 15.7335 3.33325 14.3334V5.66675C3.33325 4.26662 3.33325 3.56655 3.60574 3.03177C3.84542 2.56137 4.22787 2.17892 4.69828 1.93923C5.23306 1.66675 5.93312 1.66675 7.33325 1.66675H10.0097C10.6212 1.66675 10.9269 1.66675 11.2147 1.73582C11.4698 1.79707 11.7136 1.89808 11.9373 2.03515C12.1896 2.18975 12.4058 2.40594 12.8382 2.83832L15.495 5.49517C15.9274 5.92755 16.1436 6.14374 16.2982 6.39604C16.4353 6.61972 16.5363 6.86358 16.5975 7.11867C16.6666 7.40639 16.6666 7.71213 16.6666 8.3236Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocsIcon);
export default __webpack_public_path__ + "static/media/docs-icon.70972abb0dc4a157ba68666ee7f2f422.svg";
export { ForwardRef as ReactComponent };